import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateUserGroup = (props) => {
    const [UserGroup, setUserGroup] = useState('');
    const [AccountGroupID, setAccountGroupID] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();
    const [AccountGroupcmb, setAccountGroupcmb] = useState([]);
    const [responseCombo, fetchComboData] = UseFetchData();


    const validationSchema = Yup.object({
        UserGroup: Yup.string().required('Required!'),
        // AccountGroupID: Yup.string().max(5).required('Required!'),
    });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'UserGroup');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.UserGroup);
        bodyFormData.append("Value2", values.AccountGroupID);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'UserGroup');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    const AccountData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'accountgroup');
        fetchComboData("Primary/List", bodyFormData);
    }

    const ACCGroupdataOpt = (AccountGroupOption) => {
        // debugger;
        let AccountGroupCombo = AccountGroupOption.map((data) =>
            <option
                key={data.AccountGroup}
                value={data.id}
            >
                {data.AccountGroup}
            </option>
        );
        setAccountGroupcmb(AccountGroupCombo);
    };

    useEffect(() => {
        // debugger;
        ACCGroupdataOpt(responseCombo);
    }, [responseCombo])

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    useEffect(() => {
        if (responseGetData.length > 0) {
            setUserGroup(responseGetData[0].UserGroup);
            setAccountGroupID(responseGetData[0].AccountGroupID);
        }
    }, [responseGetData])

    useEffect(() => {
        AccountData();
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ UserGroup: UserGroup, AccountGroupID: AccountGroupID }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='UserGroup'
                                    name='UserGroup'
                                    onChange={(e) => setUserGroup(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='AccountGroup'
                                    name='AccountGroupID'
                                    options={AccountGroupcmb}
                                    onChange={(e) => setAccountGroupID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateUserGroup;
